module.exports = __webpack_public_path__ + "img/test-opt-bg.c51ef305.png";